module.exports = __webpack_public_path__ + "media/site/images/banners/banner-contact-b9e39138a6a72a144f09616322f2671d.png";